var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.78 196.991V233.201H130.74C130.74 235.211 129.42 237.201 126.76 238.741C121.46 241.791 112.87 241.791 107.59 238.741C104.95 237.201 103.61 235.211 103.61 233.201V196.991H130.79H130.78Z",
    fill: "#72D09A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.78 202.521C121.48 205.571 112.89 205.571 107.61 202.521C102.31 199.471 102.31 194.511 107.61 191.441C112.91 188.391 121.5 188.391 126.78 191.441C132.08 194.511 132.08 199.471 126.78 202.521Z",
    fill: "#A7CFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.46 238.061L65.77 189.761V29.251L149.46 77.571V238.061Z",
    fill: "#B2E8C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6799 172.211C98.6799 178.331 94.3699 180.821 89.0699 177.751C83.7699 174.681 79.46 167.231 79.46 161.111C79.46 154.991 83.7699 152.501 89.0699 155.571C94.3699 158.641 98.6799 166.091 98.6799 172.211Z",
    fill: "#F97E73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3101 170.261C95.3101 174.241 92.5201 175.841 89.0801 173.851C85.6401 171.861 82.8501 167.031 82.8501 163.071C82.8501 159.691 84.8601 158.031 87.5701 158.831C88.0501 158.961 88.5401 159.181 89.0601 159.481C89.5801 159.781 90.08 160.151 90.55 160.561C93.3 162.901 95.3101 166.881 95.3101 170.261Z",
    fill: "#B2E8C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5701 160.541V167.511L87.5601 165.781V158.811C88.0401 158.941 88.53 159.161 89.05 159.461C89.59 159.761 90.0901 160.131 90.5701 160.541Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.41 191.101C131.41 197.221 127.1 199.711 121.8 196.641C116.5 193.591 112.19 186.121 112.19 180.001C112.19 173.881 116.5 171.391 121.8 174.461C127.12 177.531 131.41 184.981 131.41 191.101Z",
    fill: "#F97E73"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.03 189.151C128.03 193.131 125.24 194.731 121.8 192.741C118.36 190.751 115.57 185.921 115.57 181.961C115.57 178.581 117.58 176.921 120.29 177.721C120.77 177.851 121.26 178.071 121.78 178.371C122.3 178.671 122.8 179.041 123.27 179.451C126.02 181.791 128.03 185.771 128.03 189.151Z",
    fill: "#B2E8C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.31 179.461V186.431L120.3 184.701V177.731C120.78 177.861 121.27 178.081 121.79 178.381C122.31 178.681 122.83 179.051 123.31 179.461Z",
    fill: "#F97E73"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M184.23 217.981L149.46 238.061V77.5712L184.23 57.4912V217.981Z",
    fill: "#29A063"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M65.77 29.2512L100.55 8.97119C128.45 25.1412 156.34 41.3212 184.23 57.4912C172.64 64.1812 161.05 70.8812 149.46 77.5712C121.56 61.4612 93.67 45.3512 65.77 29.2512Z",
    fill: "#72D09A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.49 127.581C159.76 128.011 159.15 127.561 159.15 126.561V92.7611C159.15 91.7911 159.76 90.6411 160.49 90.2111C161.23 89.7811 161.83 90.2311 161.83 91.2311V125.031C161.81 126.031 161.22 127.171 160.49 127.581Z",
    fill: "#FECECA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.47 124.701C164.73 125.131 164.13 124.681 164.13 123.681V89.8812C164.13 88.9112 164.73 87.7612 165.47 87.3312C166.21 86.9012 166.81 87.3512 166.81 88.3512V122.151C166.81 123.141 166.21 124.291 165.47 124.701Z",
    fill: "#FECECA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.47 121.831C169.73 122.261 169.13 121.811 169.13 120.811V87.0111C169.13 86.0411 169.73 84.8911 170.47 84.4611C171.2 84.0311 171.81 84.4811 171.81 85.4811V119.281C171.79 120.271 171.2 121.421 170.47 121.831Z",
    fill: "#FECECA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.45 118.951C174.71 119.381 174.1 118.931 174.1 117.931V84.1312C174.1 83.1612 174.71 82.0112 175.45 81.5812C176.18 81.1512 176.79 81.6012 176.79 82.6012V116.421C176.79 117.391 176.18 118.541 175.45 118.951Z",
    fill: "#FECECA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9502 70.6011L121.09 89.1511V94.1711L88.9502 75.6211V70.6011Z",
    fill: "#F97E73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9502 81.1611L121.09 99.7111V104.751L88.9502 86.2011V81.1611Z",
    fill: "#F97E73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9502 91.751L121.09 110.301V115.321L88.9502 96.771V91.751Z",
    fill: "#F97E73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricA);
export default __webpack_public_path__ + "static/media/electricA.25a642d455b9f651cf2a02fe700aa358.svg";
export { ForwardRef as ReactComponent };